import {
  UPDATE_SELECTED_PLACE,
  // UPDATE_SHOW_ALL_PLACES,
  RESET_SELECTED_PLACES,
  SHOW_ALL_NEARBY_PLACES,
  SHOW_ONLY_USER_SELECTED_LOCATIONS,
} from './types';

import {MapsStateShape, MapsActionTypes, GoogleMapLocationType} from './types';

const mapsInitStatus: MapsStateShape = {
  selectedPlaces: [],
  showAllPlaces: false,
};

const placeIsNotUserSelected = place => place.type !== GoogleMapLocationType.userSelected;
const placeIsUserSelected = place => place.type === GoogleMapLocationType.userSelected;

const isNotNearbyLocation = place =>
  place.type !== GoogleMapLocationType.attraction && place.type !== GoogleMapLocationType.transit;

const isNearbyLocation = place =>
  place.type === GoogleMapLocationType.attraction || place.type === GoogleMapLocationType.transit;

export default function mapsReducer(state = mapsInitStatus, action: MapsActionTypes) {
  switch (action.type) {
    case UPDATE_SELECTED_PLACE:
      let incomingPlaces = [];
      if (!Array.isArray(action.payload?.places)) {
        incomingPlaces = [action.payload?.places];
      } else {
        incomingPlaces = action.payload?.places;
      }

      if (!Array.isArray(incomingPlaces)) {
        return state;
      }

      const prevPlacesWithoutUserSearched = state.selectedPlaces
        .filter(placeIsNotUserSelected)
        .filter(isNotNearbyLocation);

      const incomingUserSelectedPlaces = incomingPlaces.filter(placeIsUserSelected);
      const newSelectedPlacesWithCorrectUserLocations = prevPlacesWithoutUserSearched.concat(
        incomingUserSelectedPlaces,
      );

      let selectedPlaces = [];

      if (incomingPlaces.some(isNearbyLocation)) {
        const a = state.selectedPlaces.filter(isNotNearbyLocation);

        selectedPlaces = a
          .concat(incomingPlaces.filter(isNearbyLocation))
          .concat(newSelectedPlacesWithCorrectUserLocations);
      } else {
        selectedPlaces = [
          ...newSelectedPlacesWithCorrectUserLocations,
          ...state.selectedPlaces.filter(isNearbyLocation),
        ];
      }

      return {
        ...state,
        selectedPlaces: selectedPlaces,
        showAllPlaces: false,
      };

    // case UPDATE_SHOW_ALL_PLACES:
    //   return {
    //     ...state,
    //     showAllPlaces: action.payload?.showAllPlaces,
    //   };

    case RESET_SELECTED_PLACES:
      return {
        ...state,
        selectedPlaces: [],
        showAllPlaces: false,
      };

    case SHOW_ONLY_USER_SELECTED_LOCATIONS:
      const toSetSelectedPlaces = state.selectedPlaces.filter(
        place => place.type === GoogleMapLocationType.userSelected,
      );

      return {
        ...state,
        selectedPlaces: toSetSelectedPlaces,
        showAllPlaces: false,
      };

    case SHOW_ALL_NEARBY_PLACES:
      return {
        ...state,
        selectedPlaces: action.payload?.selectedPlaces,
      };
    default:
      return state;
  }
}
